export const PUBLIC_CENTERED_PATHNAMES: Array<string> = [
  '/signin',

  '/set-sign-in-method',
  '/document-drop-off',
  '/preview/document-drop-off',
  '/drop-link',
  '/template/',
  '/secure-upload',
  '/secure-share',
  '/reset-password',
] as const;

export const POSSIBLE_PUBLIC_PAGES: Array<string> = ['/help', '/design'];

export const PUBLIC_PATHNAMES: Array<string> = [
  ...PUBLIC_CENTERED_PATHNAMES,
  ...POSSIBLE_PUBLIC_PAGES,
];
